import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ReporteriaService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.headers = new HttpHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
        });
    }
    getConfig() {
        return this.httpClient.get('./assets/config/config.json');
    }
    saveLog(Modulo, Recurso, Respuesta, Stack, Estatus, Rut = null) {
        this.configuracion = this.getConfig();
        this.configuracion.subscribe((response) => {
            const API_URL = `${response['api_usabilidad']}/usabilidad/insert`;
            const data = {
                NombreTotem: localStorage.getItem('cbNombreTotem'),
                Sucursal: localStorage.getItem('cbSucursal'),
                Proyecto: response['Proyecto'],
                Modulo,
                Recurso,
                Respuesta,
                Stack,
                Estatus,
                Rut
            };
            return this.httpClient.post(API_URL, data, { headers: this.headers }).subscribe();
        });
    }
    saveTransacciones(datos) {
        this.configuracion = this.getConfig();
        this.configuracion.subscribe((response) => {
            const API_URL = `${response['api_usabilidad']}/usabilidad/transaccion`;
            const data = Object.assign({ NombreTotem: localStorage.getItem('cbNombreTotem'), Sucursal: localStorage.getItem('cbSucursal'), Proyecto: response['Proyecto'] }, datos);
            return this.httpClient.post(API_URL, data, { headers: this.headers }).subscribe();
        });
    }
}
ReporteriaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReporteriaService_Factory() { return new ReporteriaService(i0.ɵɵinject(i1.HttpClient)); }, token: ReporteriaService, providedIn: "root" });
